// extracted by mini-css-extract-plugin
module.exports = {"contentTooltip":"tooltip_contentTooltip__MJWwY","default":"tooltip_default__sqCzA","left":"tooltip_left__zoDvH","right":"tooltip_right__LTJdj","tooltip":"tooltip_tooltip__41oHn"};